// extracted by mini-css-extract-plugin
export var features = "ProFeatureComparisonTable-module__features___SH5Dc";
export var head = "ProFeatureComparisonTable-module__head___D66_Q";
export var feature = "ProFeatureComparisonTable-module__feature___jbD2Y";